/*----------------------------------------------------

	nav.js

----------------------------------------------------*/

// define the breakpoint
const breakpoint = 979;
const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

// select the navigation element
const nav = document.getElementById('nav');
const nav_button = nav.nextElementSibling;


// function to hide the popover
const hidePopover = () => {
  if(typeof nav.hidePopover === 'function'){

    nav.hidePopover();
    nav_button.setAttribute('aria-expanded','false');

    // only require inert on mobile view
    if(mediaQuery.matches){
      nav.setAttribute('inert','');
    }else{
      nav.removeAttribute('inert');
    }

  }
};


// popover state changes
const handlePopoverToggle = () => {
  if(nav.matches(':popover-open')){
    // popover is open
    nav.removeAttribute('inert');
    nav_button.setAttribute('aria-expanded', 'true');
  }else{
    // popover is closed
    hidePopover();
  }
};


// onload
if(mediaQuery.matches){
  hidePopover();
}


// event listeners
mediaQuery.addEventListener('change', hidePopover);
nav.addEventListener('toggle', handlePopoverToggle);